<script setup lang="ts">
import { onMounted, ref } from "vue";
import { RouterLink, useRoute, useRouter } from "vue-router";

import SkoreSpinner from "@/components/ui/SkoreSpinner.vue";
import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";
import { RouteNames } from "@/router";
import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const hasError = ref(false);

onMounted(async () => {
  const { access_token, refresh_token, expires_at, next } = route.query;
  if (access_token && refresh_token && expires_at) {
    // save the tokens and initialize tracking
    await authStore.handleLoginSuccess(
      access_token as string,
      refresh_token as string,
      expires_at as string
    );
    if (next && !next.includes(RouteNames.Logout)) {
      router.replace({ path: next as string });
    } else {
      router.replace({ name: RouteNames.Dispatch });
    }
  } else {
    hasError.value = true;
  }
});
</script>

<template>
  <FullPageCenteredLayout>
    <main class="login-success">
      <div class="error" v-if="hasError">
        <div class="message">Something went wrong, please try again.</div>
        <div class="link">
          <RouterLink :to="{ name: RouteNames.Login }">login</RouterLink>
        </div>
      </div>
      <SkoreSpinner v-else />
    </main>
  </FullPageCenteredLayout>
</template>

<style scoped>
.login-success {
  .error {
    .message {
      color: var(--content-negative);
    }

    .link {
      a {
        color: var(--content-primary);
      }
    }
  }
}
</style>
